/*function checkAvailability(selected){
  $('#product-variante option').each(function(){
   var option = $(this).attr('value');
   var variant = selected + " / " + option;
   var available;
   $('#productSelect option').each(function(){
     if ($(this).text().trim() == variant)  {
       available = true;
     }
   });
   if (available)  {
     $("#product-variante + ul li span:contains('"+ $(this).text() +"')").parent().removeClass('unavailable');
   } else {
     $("#product-variante + ul li span:contains('"+ $(this).text() +"')").parent().addClass('unavailable');
   }
  });
  if($('#product-variante + ul li.active.unavailable')){
    $('#product-variante + ul li:not(.unavailable)').first().click();
  }
  if($('.variant-quantity').text() == 'ausverkauft' || $('.variant-quantity').text() == 'sold out'){
    $('.variant-quantity').addClass('red');
  }
}

function variantInfo(selected){
  var fullselected = selected + " / " + $('#product-variante + ul li.active').text().trim();
  var selectedvar = $('#product-variante + ul li.active').text().trim();
  //console.log(selectedvar, fullselected);

  if($('.variant-info[data-variant="'+ fullselected +'"]').length > 0) {
    $('.variant-info[data-variant]').addClass('hidden');
    $('.variant-info[data-variant="'+ fullselected +'"]').removeClass('hidden');
  } else {
    $('.variant-info[data-variant]').addClass('hidden');
    $('.variant-info[data-variant="'+ selectedvar +'"]').removeClass('hidden');
  }
}

$(document).ready(function(){
  $(document).on("click","#product-format + ul li", function () {
     var clicked = $(this).attr('data-text');
     var selected = decodeURI(clicked);
     checkAvailability(selected);
  });

  var selected = decodeURI($('#product-format + ul li.active').attr('data-text'));
  checkAvailability(selected);
  
  $(document).on('click','select.product-variants + ul li', function(){
    selected = decodeURI($('#product-format + ul li.active').attr('data-text'));
 	variantInfo(selected);
  });
  variantInfo(selected);
});*/

function variantInfo(selected){
  var infodiv = document.querySelector('[data-variant="' + selected + '"]');
  var allinfos = document.querySelectorAll('.variant-info');
  for (var info of allinfos){
    info.classList.add('hidden'); 
  }
  if(infodiv){
    infodiv.classList.remove('hidden');
  }
}

window.addEventListener('load', function(){
  //var data = JSON.parse(document.getElementById("productjson").innerHTML);
  //console.log(data);
  var variant = document.querySelector("input[name='Variante']:checked").getAttribute("value");
  variantInfo(variant);

  document.addEventListener('click', function(ev){
    if(!ev.target.matches('label[data-option="Variante"]')) return;
    var variant = ev.target.innerHTML.trim();
    //console.log(variant)
    variantInfo(variant);
  })
  
}, false)

